import React, { useState, useEffect, useMemo, useCallback } from "react";

import {
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import moment from "moment";
import { ExpandMore } from "@material-ui/icons";

import { useDebouncedEffect } from "@hooks/debounceEffect";
import { useStore } from "@store/store";
import Header from "@components/header";
import SearchIcon from "@assets/images/search.svg";
import { materialCommonStyles } from "@utils/materialCommonStyles";

import { dataJobStatus } from "@utils/constant";
import {
  getFilter,
  setFilter,
  removeFilter,
  getTimeZone,
  setInterstateMode,
  getInterstateMode,
} from "@utils/commonFunctions";

import {
  FETCH_JOBS,
  FETCH_JOBS_SUCCESS,
  FETCH_JOBS_FAILURE,
  FETCH_JOBS_RELOAD_DATA,
  RESET_REDIRECTION,
  FETCH_INTERSTATE_JOBS_RELOAD_DATA,
  FETCH_INTERSTATE_JOBS,
  FETCH_INTERSTATE_JOBS_SUCCESS,
  FETCH_INTERSTATE_JOBS_FAILURE
} from "@utils/actionTypes";
import { getApi } from "@services/axios";
import { rowsPerPageVal } from "@utils/constant";
import { JobListingStyle } from "./style";
import Filter from "./filter";
import TableListing from "./table-listing";
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';

function JobListing() {
  const classes = JobListingStyle();
  const dashboardFilter = getFilter("jobDashboardFilter", true);
  const filter = getFilter("jobFilter", true);
  const allocateFilter = parseInt(getFilter("jobAllocate"));
  const cargoVolumeFilter = getFilter("cargoVolume");
  const materilClasses = materialCommonStyles();
  const [state, dispatch] = useStore();
  const [openFilter, setOpenFilter] = useState(false);
  const [allocate, setAllocate] = useState(
    !!allocateFilter ? parseInt(allocateFilter) : ""
  );
  const [isInterstateSwitch, setIsInterstateSwitch] = useState(!!JSON.parse(getInterstateMode("interstate")));
  const [dataTable, setData] = useState({});

  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [period, setPeriod] = useState(
    filter ? filter?.period : ""
  );
  const [openStartJob, setOpenStartJob] = useState(false);
  const [showStartJob, setShowStartJob] = useState(false);
  const [startJobPeriod, setStartJobPeriod] = useState(
    filter ? filter?.startJobPeriod : dashboardFilter ? dashboardFilter.period : ""
  );
  const [filterData, setFilterData] = useState({
    jobStatus: filter ? filter.jobStatus : [],
    jobType: filter
      ? filter?.jobType
      : dashboardFilter
      ? dashboardFilter.jobType
        : [],
    customer: filter
      ? filter?.customer
      : dashboardFilter
        ? dashboardFilter.customer
        : [],
    cargoType: cargoVolumeFilter
      ? Array.isArray(cargoVolumeFilter) ? cargoVolumeFilter : [parseInt(cargoVolumeFilter)]
      : filter
      ? filter.cargoType
      : dashboardFilter
      ? dashboardFilter.cargoType
      : [],
    driver: filter ? filter.driver : [],
    truckRego: filter ? filter.truckRego : [],
    cto: filter ? filter?.cto : dashboardFilter ? dashboardFilter.cto : [],
    city: filter ? filter?.city : dashboardFilter ? dashboardFilter.city : [],
    startDate: filter
      ? filter?.startDate
      : "",
    endDate: filter
      ? filter?.endDate
      : "",
    startJobStartDate: filter
        ? filter?.startJobStartDate
        : dashboardFilter
        ? dashboardFilter.startDate
        : "",
    startJobEndDate: filter
        ? filter?.startJobEndDate
        : dashboardFilter
        ? dashboardFilter.endDate
        : "",
    trailerRego: [],
    pickUpCity: [],
    dropOffCity: [],
    coldTrackingVehicle: false
  });
  const [customDate, setCustomDate] = useState({
    startDate: null,
    endDate: null,
  });
  const [startJobCustomDate, setStartJobCustomDate] = useState({
    startJobStartDate: null,
    startJobEndDate: null,
  });
  const [updateFilter, setUpdateFilter] = useState({});
  const [search, setSearch] = useState("");
  const [debounceSearch, setDebounceSearch] = useState("");
  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage: rowsPerPageVal
  });
  const [sort, setSort] = useState({
    order: "",
    orderBy: ""
  });

  const paramsGetJob = useMemo(() => {
    return {
      page: pagination.page + 1,
      size: pagination.rowsPerPage,
      ...(!!debounceSearch ? { search: debounceSearch } : {}),
      ...(!!sort.order ? { order: sort.order } : {}),
      ...(!!sort.orderBy ? { orderBy: sort.orderBy } : {}),

      filter: {
        ...(allocate === 1 ? { durationOver3Hours: 1 } : {}),
        ...(allocate === 2 ? { waitingTimeOver2Hours: 1 } : {}),
        ...(allocate === 3 ? { AWBNotTakenFully: 1 } : {}),
        ...(!!filterData.jobStatus.length
          ? { jobStatusId: filterData.jobStatus }
          : {}),
        ...(!!filterData.jobType.length
          ? { jobTypeId: filterData.jobType }
          : {}),
        ...(!!filterData.cargoType.length
          ? { cargoTypeId: filterData.cargoType }
          : {}),
        ...(!!filterData.driver.length ? { driverId: filterData.driver } : {}),
        ...(!!filterData.truckRego.length
          ? { truckId: filterData.truckRego }
          : {}),
        ...(state?.common?.truckId
          ? { truckId: [state.common.truckId.truckId] }
          : {}),
        ...(!!filterData.cto.length ? { ctoId: filterData.cto } : {}),
        ...(!!filterData?.city?.length ? { cityId: filterData.city } : {}),
        ...(!!filterData.startDate
          ? { startDate: filterData.startDate }
          : !!customDate.startDate
          ? { startDate: filterData.startDate }
          : {}),
        ...(state?.common?.truckId
          ? { startDate: state?.common?.truckId.startDate }
          : {}),
        ...(!!filterData.endDate
          ? { endDate: filterData.endDate }
          : !!customDate.endDate
          ? { endDate: filterData.endDate }
          : {}),
        ...(state?.common?.truckId
          ? { endDate: state?.common?.truckId.endDate }
          : {}),
        ...(!!filterData.startJobStartDate
          ? { startJobStartDate: filterData.startJobStartDate }
          : !!startJobCustomDate.startJobStartDate
          ? { startJobStartDate: filterData.startJobStartDate }
          : {}),
        ...(!!filterData.startJobEndDate
          ? { startJobEndDate: filterData.startJobEndDate }
          : !!startJobCustomDate.startJobEndDate
          ? { startJobEndDate: filterData.startJobEndDate }
          : {}),
      },
      timezone: getTimeZone()
    };
  }, [
    pagination,
    debounceSearch,
    sort,
    allocate,
    filterData,
    state.common.truckId,
    customDate,
    startJobCustomDate,
  ]);

  const paramsGetInterstateJob = useMemo(() => {
    return {
      page: pagination.page + 1,
      size: pagination.rowsPerPage,
      ...(!!debounceSearch ? { search: debounceSearch } : {}),
      ...(!!sort.order ? { order: sort.order } : {}),
      ...(!!sort.orderBy ? { orderBy: sort.orderBy } : {}),

      filter: {
        ...(allocate === 1 ? { durationOver3Hours: 1 } : {}),
        ...(allocate === 2 ? { waitingTimeOver2Hours: 1 } : {}),
        ...(allocate === 3 ? { withoutJobCharge: 1 } : {}),
        ...(allocate === 4 ? { reviewNotCompleted: 1 } : {}),
        ...(allocate === 5 ? { AWBNotTakenFully: 1 } : {}),
        ...(allocate === 6 ? { childAccountNotMapped: 1 } : {}),
        ...(!!filterData?.jobStatus?.length
          ? { jobStatusId: filterData.jobStatus }
          : {}),
        ...(!!filterData?.truckRego?.length
          ? { truckId: filterData.truckRego }
          : {}),
        ...(!!filterData?.trailerRego?.length
          ? { trailerId: filterData.trailerRego }
          : {}),
        ...(!!filterData?.driver?.length ? { driverId: filterData.driver } : {}),
        ...(!!filterData?.customer?.length
          ? { customerId: filterData.customer }
          : {}),
        ...(!!filterData?.pickUpCity?.length
          ? { pickUpCityId: filterData.pickUpCity }
          : {}),
        ...(!!filterData?.dropOffCity?.length
          ? { dropOffCityId: filterData.dropOffCity }
          : {}),
        ...(!!filterData.startDate
          ? { startDate: filterData.startDate }
          : !!customDate.startDate
            ? { startDate: filterData.startDate }
            : {}),
        ...(state?.common?.truckId
          ? { startDate: state?.common?.truckId.startDate }
          : {}),
        ...(!!filterData.endDate
          ? { endDate: filterData.endDate }
          : !!customDate.endDate
            ? { endDate: filterData.endDate }
            : {}),
        ...(state?.common?.truckId
          ? { endDate: state?.common?.truckId.endDate }
          : {}),
        ...(!!filterData.startJobStartDate
          ? { startJobStartDate: filterData.startJobStartDate }
          : !!startJobCustomDate.startJobStartDate
            ? { startJobStartDate: filterData.startJobStartDate }
            : {}),
        ...(!!filterData.startJobEndDate
          ? { startJobEndDate: filterData.startJobEndDate }
          : !!startJobCustomDate.startJobEndDate
            ? { startJobEndDate: filterData.startJobEndDate }
            : {}),
        ...(filterData.coldTrackingVehicle
          ? { isColdTrackingVehicle: filterData.coldTrackingVehicle }
          : {})
      }
    };
  }, [
    pagination,
    debounceSearch,
    sort,
    allocate,
    filterData,
    customDate,
    startJobCustomDate,
    state?.common?.truckId
  ]);

  let getInterstateJobs = useCallback((payload = paramsGetInterstateJob, needReloadData = false) => {
    dispatch({ type: needReloadData ? FETCH_INTERSTATE_JOBS_RELOAD_DATA : FETCH_INTERSTATE_JOBS });
    let params = payload;
    getApi("interstateJobs", { params })
      .then((response) => {
        dispatch({
          type: FETCH_INTERSTATE_JOBS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_INTERSTATE_JOBS_FAILURE, payload: error });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsGetInterstateJob]);

  let getJobs = useCallback((payload= paramsGetJob, needReloadData = false) => {
    dispatch({ type: needReloadData ? FETCH_JOBS_RELOAD_DATA : FETCH_JOBS});
    let params = payload;
    getApi("jobs", { params })
      .then((response) => {
        dispatch({
          type: FETCH_JOBS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_JOBS_FAILURE, payload: error });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsGetJob]);
  

  useEffect(() => {
    try {
      if (state?.common?.truckId) {
        setShow(true);
        setPeriod(7);
        setFilterData({
          ...filterData,
          truckRego: [state?.common?.truckId.truckId],
          startDate: state?.common?.truckId.startDate,
          endDate: state?.common?.truckId.endDate,
        });
        setCustomDate({
          ...customDate,
          startDate: state?.common?.truckId.startDate,
          endDate: state?.common?.truckId.endDate,
        });
      }
    } catch (error) {
      console.log("Error", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pagination,
    sort,
    state?.common?.truckId,
    period,
    debounceSearch,
  ]);

  useEffect(() => {
    if(state?.redirection?.jobStatusRedirection) {
      setFilterData({
        ...filterData,
        jobStatus: [
          dataJobStatus.find(
              (item) => item.name === state?.redirection?.jobStatusRedirection
          ).id,
        ],
      });
      const payload = {
        ...paramsGetJob,
        filter: {
          ...paramsGetJob?.filter,
          jobStatusId: [
            dataJobStatus.find(
                (item) => item.name === state?.redirection?.jobStatusRedirection
            ).id
          ]
        }
      };
      getJobs(payload);
    }
    return () =>
      dispatch({
        type: RESET_REDIRECTION,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state?.redirection?.filterRedirection,
    updateFilter
  ]);

  useEffect(() => {
    if (state?.common?.truckId) {
      setFilter(
        "jobFilter",
        {
          ...filterData,
          startDate: customDate.startDate,
          endDate: customDate.endDate,
        },
        true
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customDate, filterData, state?.common?.truckId]);

  useEffect(() => {
    setFilter("jobAllocate", allocateFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Debounce the search after 1 second
  useDebouncedEffect(
    () => {
      setDebounceSearch(search);
      resetPagination();
      if (!isInterstateSwitch) { // For Local
        const getParamsGetJob = {
          ...paramsGetJob
        };
        delete getParamsGetJob?.search;

        const payload = {
          ...getParamsGetJob,
          page: 1,
          size: rowsPerPageVal,
          ...(!!search ? { search: search } : delete getParamsGetJob?.search)
        };
        getJobs(payload);
      } else { // For Interstate
        const getParamsGetInterstateJob = {
          ...paramsGetInterstateJob
        };
        delete getParamsGetInterstateJob?.search;

        const payload = {
          ...getParamsGetInterstateJob,
          page: 1,
          size: rowsPerPageVal,
          ...(!!search ? { search: search } : delete getParamsGetInterstateJob?.search)
        };
        getInterstateJobs(payload);
      }
    },
    1000,
    [search]
  );

  const handleCustomDateSubmit = () => {
    setOpen(false);
    setShow(true);
    setFilterData({
      ...filterData,
      startDate: customDate.startDate,
      endDate: customDate.endDate,
    });
    if (!openFilter) {
      setUpdateFilter(filterData);
    }
    setPeriod(7);
  };
  const handleStartJobCustomDateSubmit = () => {
    setOpenStartJob(false);
    setShowStartJob(true);
    setFilterData({
      ...filterData,
      startJobStartDate: startJobCustomDate.startJobStartDate,
      startJobEndDate: startJobCustomDate.startJobEndDate,
    });
    if (!openFilter) {
      setUpdateFilter(filterData);
    }
    setStartJobPeriod(7);
  };

  const handleFilter = (event) => {
    const { name, value } = event.target;
    setFilterData({
      ...filterData,
      [name]: value,
    });
    if (!openFilter) {
      setUpdateFilter(filterData);
    }
  };
  const openFilterPopup = () => {
    document.body.classList.toggle("open-filter");
    setOpenFilter(true);
  };

  const closeFilerPopup = () => {
    document.body.classList.remove("open-filter");
    setOpenFilter(false);
  };

  const handleClose = () => {
    setPeriod("");
    setOpen(false);
    setCustomDate({
      startDate: null,
      endDate: null,
    });
    setFilterData({
      ...filterData,
      startDate: null,
      endDate: null,
    });
  };

  const handleStartJobClose = () => {
    setStartJobPeriod("");
    setOpenStartJob(false);
    setStartJobCustomDate({
      startJobStartDate: null,
      startJobEndDate: null,
    });
    setFilterData({
      ...filterData,
      startJobStartDate: null,
      startJobEndDate: null,
    });
  };

  const handleCustomChange = (event, type) => {
    if (type === "startDate" || type === "endDate") {
      setCustomDate({
        ...customDate,
        [type]: moment(event).format("YYYY-MM-DD"),
      });
    } else {
      const { name, value } = event.target;
      setCustomDate({
        ...customDate,
        [name]: value,
      });
    }
  };
  const handleStartJobCustomChange = (event, type) => {
    if (type === "startJobStartDate" || type === "startJobEndDate") {
      setStartJobCustomDate({
        ...startJobCustomDate,
        [type]: moment(event).format("YYYY-MM-DD"),
      });
    } else {
      const { name, value } = event.target;
      setStartJobCustomDate({
        ...startJobCustomDate,
        [name]: value,
      });
    }
  };
  const handleAllocate = (event) => {
    setAllocate(event.target.value);
    setFilter("jobAllocate", event.target.value);
    resetPagination();

    const getParamsGetJob = {
      ...paramsGetJob
    };
    delete getParamsGetJob?.filter?.durationOver3Hours;
    delete getParamsGetJob?.filter?.waitingTimeOver2Hours;
    delete getParamsGetJob?.filter?.AWBNotTakenFully;
    const payload = {
      ...getParamsGetJob,
      page: 1,
      size: rowsPerPageVal,
      filter: {
        ...getParamsGetJob?.filter,
        ...(event.target.value === 1 ? { durationOver3Hours: 1 } : {}),
        ...(event.target.value === 2 ? { waitingTimeOver2Hours: 1 } : {}),
        ...(event.target.value === 3 ? { AWBNotTakenFully: 1 } : {}),
      }
    };
    getJobs(payload);
  };

  const handlePeriodChange = (event, type) => {
    const { value } = event.target;
    setPeriod(value);
    setShow(false);
    if (!openFilter) {
      setFilter(
        "jobFilter",
        {
          ...filterData,
          period: value,
        },
        true
      );
    }
    if (value === 7 || type === true) {
      setOpen(true);
    } else {
      const newDate = new Date();
      if (value === "") {
        setFilterData({
          ...filterData,
          startDate: null,
          endDate: null,
        });
        setCustomDate({
          startDate: null,
          endDate: null,
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 1) {
        setFilterData({
          ...filterData,
          startDate: moment(newDate).format("YYYY-MM-DD"),
          endDate: moment(newDate).format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 2) {
        setFilterData({
          ...filterData,
          startDate: moment(newDate).subtract(1, "day").format("YYYY-MM-DD"),
          endDate: moment(newDate).subtract(1, "day").format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 3) {
        setFilterData({
          ...filterData,
          startDate: moment(newDate).subtract(3, "day").format("YYYY-MM-DD"),
          endDate: moment(newDate).format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 4) {
        setFilterData({
          ...filterData,
          startDate: moment(newDate).subtract(7, "day").format("YYYY-MM-DD"),
          endDate: moment(newDate).format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 5) {
        setFilterData({
          ...filterData,
          startDate: moment(newDate).subtract(14, "day").format("YYYY-MM-DD"),
          endDate: moment(newDate).format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 6) {
        setFilterData({
          ...filterData,
          startDate: moment(newDate).subtract(30, "day").format("YYYY-MM-DD"),
          endDate: moment(newDate).format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      }
    }
  };
  const handleStartJobPeriodChange = (event, type) => {
    const { value } = event.target;
    setStartJobPeriod(value);
    setShowStartJob(false);
    if (!openFilter) {
      setFilter(
        "jobFilter",
        {
          ...filterData,
          startJobPeriod: value,
        },
        true
      );
    }
    if (value === 7 || type === true) {
      setOpenStartJob(true);
    } else {
      const newDate = new Date();
      if (value === "") {
        setFilterData({
          ...filterData,
          startJobStartDate: null,
          startJobEndDate: null,
        });
        setStartJobCustomDate({
          startJobStartDate: null,
          startJobEndDate: null,
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 1) {
        setFilterData({
          ...filterData,
          startJobStartDate: moment(newDate).format("YYYY-MM-DD"),
          startJobEndDate: moment(newDate).format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 2) {
        setFilterData({
          ...filterData,
          startJobStartDate: moment(newDate)
            .subtract(1, "day")
            .format("YYYY-MM-DD"),
          startJobEndDate: moment(newDate)
            .subtract(1, "day")
            .format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 3) {
        setFilterData({
          ...filterData,
          startJobStartDate: moment(newDate)
            .subtract(3, "day")
            .format("YYYY-MM-DD"),
          startJobEndDate: moment(newDate).format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 4) {
        setFilterData({
          ...filterData,
          startJobStartDate: moment(newDate)
            .subtract(7, "day")
            .format("YYYY-MM-DD"),
          startJobEndDate: moment(newDate).format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 5) {
        setFilterData({
          ...filterData,
          startJobStartDate: moment(newDate)
            .subtract(14, "day")
            .format("YYYY-MM-DD"),
          startJobEndDate: moment(newDate).format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      } else if (value === 6) {
        setFilterData({
          ...filterData,
          startJobStartDate: moment(newDate)
            .subtract(30, "day")
            .format("YYYY-MM-DD"),
          startJobEndDate: moment(newDate).format("YYYY-MM-DD"),
        });
        if (!openFilter) {
          setUpdateFilter(filterData);
        }
      }
    }
  };
  const handleSubmit = () => {
    resetPagination();

    if (!isInterstateSwitch) { // For Local
      const payload = {
        ...paramsGetJob,
        page: 1,
        size: rowsPerPageVal,
      };
      getJobs(payload);
    } else { // For Interstate
      const payload = {
        ...paramsGetInterstateJob,
        page: 1,
        size: rowsPerPageVal,
      };
      getInterstateJobs(payload);
    }
    setFilter("jobFilter", { ...filterData, period, startJobPeriod }, true);
    closeFilerPopup();
  };
  const handleReset = (needReloadData = false) => {
    document.body.classList.remove("open-filter");
    removeFilter("jobFilter");
    removeFilter("jobDashboardFilter");
    removeFilter("jobAllocate");
    removeFilter("cargoVolume");
    setShow(false);
    setPeriod("");
    setShowStartJob(false);
    setStartJobPeriod("");
    setFilterData({
      jobStatus: [],
      jobType: [],
      cargoType: [],
      customer: [],
      cto: [],
      city: [],
      startDate: null,
      endDate: null,
      startJobStartDate: null,
      startJobEndDate: null,
      truckRego: [],
      driver: [],
      trailerRego: [],
      pickUpCity: [],
      dropOffCity: [],
      coldTrackingVehicle: false
    });
    setCustomDate({
      startDate: null,
      endDate: null,
    });
    setStartJobCustomDate({
      startJobStartDate: null,
      startJobEndDate: null,
    });

    setUpdateFilter({
      jobStatus: [],
      jobType: [],
      cargoType: [],
      cto: [],
      city: [],
      startDate: null,
      endDate: null,
      startJobStartDate: null,
      startJobEndDate: null,
      truckRego: [],
      driver: [],
    });
    resetPagination();

    if (!isInterstateSwitch) {
      const payload = {
        ...paramsGetJob,
        page: 1,
        size: rowsPerPageVal,
        filter: {
          ...(!!paramsGetJob?.filter?.durationOver3Hours ? { durationOver3Hours: paramsGetJob?.filter?.durationOver3Hours } : {}),
          ...(!!paramsGetJob?.filter?.waitingTimeOver2Hours ? { waitingTimeOver2Hours: paramsGetJob?.filter?.waitingTimeOver2Hours } : {}),
          ...(!!paramsGetJob?.filter?.AWBNotTakenFully ? { AWBNotTakenFully: paramsGetJob?.filter?.AWBNotTakenFully } : {})
        }
      };
      getJobs(payload, needReloadData);
    } else {
      const payload = {
        ...paramsGetInterstateJob,
        page: 1,
        size: rowsPerPageVal,
        filter: {
          ...(!!paramsGetJob?.filter?.durationOver3Hours ? { durationOver3Hours: paramsGetJob?.filter?.durationOver3Hours } : {}),
          ...(!!paramsGetJob?.filter?.waitingTimeOver2Hours ? { waitingTimeOver2Hours: paramsGetJob?.filter?.waitingTimeOver2Hours } : {}),
          ...(!!paramsGetJob?.filter?.AWBNotTakenFully ? { AWBNotTakenFully: paramsGetJob?.filter?.AWBNotTakenFully } : {}),
          ...(!!paramsGetJob?.filter?.withoutJobCharge ? { withoutJobCharge: paramsGetJob?.filter?.withoutJobCharge } : {}),
          ...(!!paramsGetJob?.filter?.reviewNotCompleted ? { reviewNotCompleted: paramsGetJob?.filter?.reviewNotCompleted } : {}),
          ...(!!paramsGetJob?.filter?.childAccountNotMapped ? { childAccountNotMapped: paramsGetJob?.filter?.childAccountNotMapped } : {})
        }
      };
      getInterstateJobs(payload, needReloadData);
    }

  };

  const handleSearch = (event) => {
    setSearch(event.target.value.trimStart());
  };

  const handleSorting = (event, property) => {
    const isAsc = sort.orderBy === property.sortTitle && sort.order === "asc";
    setSort(prev => (
      {
        ...prev,
        order: isAsc ? "desc" : "asc",
        orderBy: property.sortTitle
      }
    ));
    resetPagination();

   if (!isInterstateSwitch) { // For Local
      const getParamsGetJob = { ...paramsGetJob };
      delete getParamsGetJob?.order;
      delete getParamsGetJob?.orderBy;
      const payload = {
        ...getParamsGetJob,
        page: 1,
        size: rowsPerPageVal,
        order: isAsc ? "desc" : "asc",
        orderBy: property.sortTitle
      };
      getJobs(payload);
    } else { // For Interstate
      const getParamsGetInterstateJob = { ...paramsGetInterstateJob };
      delete getParamsGetInterstateJob?.order;
      delete getParamsGetInterstateJob?.orderBy;
      const payload = {
        ...getParamsGetInterstateJob,
        page: 1,
        size: rowsPerPageVal,
        order: isAsc ? "desc" : "asc",
        orderBy: property.sortTitle
      };
      getInterstateJobs(payload);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPagination((prev) => (
      {
        ...prev,
        page: newPage
      }
    ));
    if (!isInterstateSwitch) { // For Local
      const payload = {
        ...paramsGetJob,
        page: newPage + 1
      };
      getJobs(payload);
    } else { // For Interstate
      const payload = {
        ...paramsGetInterstateJob,
        page: newPage + 1
      };
      getInterstateJobs(payload);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination(prev => (
      {
        ...prev,
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0
      }
    ));

    if (!isInterstateSwitch) {
      const payload = {
        ...paramsGetJob,
        page: 1,
        size: parseInt(event.target.value, 10),
      };
      getJobs(payload);
    } else {
      const payload = {
        ...paramsGetInterstateJob,
        page: 1,
        size: parseInt(event.target.value, 10),
      };
      getInterstateJobs(payload);
    }
  };

  const resetPagination = () => {
    setPagination(prev => (
      {
        ...prev,
        page: 0,
        rowsPerPage: rowsPerPageVal
      }
    ));
  }

  const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#0066ff',
          opacity: 1,
          border: 0,
          ...theme.applyStyles('dark', {
            backgroundColor: '#0066ff',
          }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#0066ff',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.grey[100],
        ...theme.applyStyles('dark', {
          color: theme.palette.grey[600],
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
        ...theme.applyStyles('dark', {
          opacity: 0.3,
        }),
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: '#E9E9EA',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
      ...theme.applyStyles('dark', {
        backgroundColor: '#39393D',
      }),
    },
  }));

  useEffect(() => {
    handleReset(true);
  }, [isInterstateSwitch]);

  const handleSwitchChange = (event) => {
    setIsInterstateSwitch(event.target.checked);
    setSearch('');
    setAllocate('');
    if (!event.target.checked) { // For Local
      delete paramsGetJob?.search;
      delete paramsGetJob?.order;
      delete paramsGetJob?.orderBy;
    } else { // For Interstate
      delete paramsGetInterstateJob?.search;
      delete paramsGetInterstateJob?.order;
      delete paramsGetInterstateJob?.orderBy;
    }
    setSort({
      order: "",
      orderBy: ""
    });
    setInterstateMode("interstate", event.target.checked);
  }

  const handleSwitchColdTrackingVehicle = (event) => {
    filterData.coldTrackingVehicle = event.target.checked;
    setFilterData({
      ...filterData,
      isColdTrackingVehicle: event.target.checked
    });
    resetPagination();

    const payload = {
      ...paramsGetInterstateJob,
      page: 1,
      size: rowsPerPageVal,
      filter: {
        ...paramsGetInterstateJob.filter,
        isColdTrackingVehicle: event.target.checked
      }
    };
    getInterstateJobs(payload);
  }

  return (
    <>
      <Header />
      <div className={classes.JobListingWrapper}>
        <div className="dashboard-page wrapper">
          <div className="inner-page">
            <div className="title-panel">
              <Typography variant="h1">Jobs</Typography>
            </div>
            <div className={classes.innerPageTopBlock}>
              <div className="left-block">
                <FormGroup>
                  <Typography variant="h6">Interstate</Typography>
                  <FormControlLabel
                    control={<IOSSwitch sx={{ m: 1 }} checked={isInterstateSwitch} onChange={handleSwitchChange} />}
                  />
                </FormGroup>
              </div>

              <div className="right-block">
                <div className="right-block-inner">
                  <div className="search-wrapper">
                    <div className="form-gourp">
                      <TextField
                        id="search-request"
                        placeholder="Search by ID/AWB/Cons./ULD/Info"
                        variant="outlined"
                        type="search"
                        InputProps={{
                          endAdornment: <img src={SearchIcon} alt="Search" />,
                        }}
                        value={search}
                        onChange={handleSearch}
                      />
                    </div>
                  </div>
                  {!isInterstateSwitch && (
                    <div className="dropdown_wrapper">
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <Select
                          value={allocate}
                          onChange={handleAllocate}
                          displayEmpty
                          className={materilClasses.customSelect}
                          MenuProps={{
                            classes: { paper: materilClasses.customSelect },
                          }}
                          IconComponent={() => <ExpandMore />}
                        >
                          <MenuItem value={""}>Choose</MenuItem>
                          <MenuItem value={1}>Duration Over 3 Hours</MenuItem>
                          <MenuItem value={2}>Waiting Time Over 2 Hours</MenuItem>
                          <MenuItem value={3}>
                            Jobs whose AWB not taken fully
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>)
                  }
                  <div className="dropdown_wrapper1">
                    <div className={classes.filter}>
                      <Filter
                        handleFilter={handleFilter}
                        filterData={filterData}
                        openFilterPopup={openFilterPopup}
                        closeFilerPopup={closeFilerPopup}
                        handleSubmit={handleSubmit}
                        handlePeriodChange={handlePeriodChange}
                        handleClose={handleClose}
                        handleCustomChange={handleCustomChange}
                        handleCustomDateSubmit={handleCustomDateSubmit}
                        period={period}
                        open={open}
                        show={show}
                        customDate={customDate}
                        startJobPeriod={startJobPeriod}
                        openStartJob={openStartJob}
                        showStartJob={showStartJob}
                        startJobCustomDate={startJobCustomDate}
                        handleStartJobPeriodChange={handleStartJobPeriodChange}
                        handleStartJobCustomChange={handleStartJobCustomChange}
                        handleStartJobCustomDateSubmit={
                          handleStartJobCustomDateSubmit
                        }
                        handleStartJobClose={handleStartJobClose}
                        handleReset={handleReset}
                        openFilter={openFilter}
                        isInterstate={isInterstateSwitch}
                        handleSwitchColdTrackingVehicle = {handleSwitchColdTrackingVehicle}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <TableListing
              page={pagination.page}
              handleChangePage={handleChangePage}
              rowsPerPage={pagination.rowsPerPage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              handleSorting={(e, property) => handleSorting(e, property)}
              orderBy={sort.orderBy}
              order={sort.order}
              getJobs={getJobs}
              getInterstateJobs={getInterstateJobs}
              isInterstate={isInterstateSwitch}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default JobListing;
